import { getApolloClient } from '../lib/getApolloClient';
import { handleGraphQLErrors } from '../util/graphqlError.util';
import { REQUEST_PREDICTIVE_SHIFT_REPORT_EXPORT } from './report.gql';

export type RequestPredictiveShiftReportExportResult = {
  id: string;
  status: string;
};

export const requestPredictiveShiftReportExport = async (params: {
  tenantId: string;
  startDate: string;
  endDate: string;
  includeUnfilledShifts?: boolean;
}): Promise<RequestPredictiveShiftReportExportResult> => {
  const { data, errors } = await getApolloClient().mutate<{
    requestPredictiveShiftReportExport: RequestPredictiveShiftReportExportResult;
  }>({
    mutation: REQUEST_PREDICTIVE_SHIFT_REPORT_EXPORT,
    variables: {
      tenantId: params.tenantId,
      startDate: params.startDate,
      endDate: params.endDate,
      includeUnfilledShifts: params.includeUnfilledShifts ?? true,
    },
  });

  handleGraphQLErrors(errors);

  const result = data?.requestPredictiveShiftReportExport;
  if (!result?.id) {
    throw new Error('Failed to queue predictive shift report export');
  }

  return result;
};
